import { NavLink } from "./NavLink";
import { Mail, Phone } from "lucide-react";
import logo from "@/assets/logo.png";
import { GENERAL_PHONE, trackPhoneClick } from "@/config/contact";

const Footer = () => {
  const year = new Date().getFullYear();

  const columns = [
    {
      title: "De reis van de leerling",
      links: [
        { to: "/lob-reis", label: "De LOB-reis" },
        { to: "/voor-leerlingen", label: "Voor leerlingen" },
        { to: "/lob-leerlijn", label: "LOB-leerlijn" },
        { to: "/leerlingprofiel", label: "Leerlingprofiel" },
        { to: "/opleidingen", label: "Opleidingen ontdekken" },
      ],
    },
    {
      title: "Platform",
      links: [
        { to: "/hoe-werkt-het", label: "Doorlopend LOB-dossier" },
        { to: "/dashboard", label: "Klas- en schooloverzicht" },
        { to: "/voor-mentoren", label: "Voor mentoren & decanen" },
        { to: "/keuzehulp", label: "Keuzehulp" },
      ],
    },
    {
      title: "Scholen",
      links: [
        { to: "/voor-scholen", label: "Voor scholen" },
        { to: "/resultaten", label: "Resultaten" },
        { to: "/integratie", label: "Implementatie" },
        { to: "/prijzen", label: "Prijzen" },
        { to: "/demo", label: "Plan een kennismaking" },
      ],
    },
    {
      title: "studie connect",
      links: [
        { to: "/over-ons", label: "Over ons" },
        { to: "/informatie-ouders", label: "Informatie voor ouders" },
        { to: "/veelgestelde-vragen", label: "Veelgestelde vragen" },
        { to: "/blog", label: "Blog" },
        { to: "/contact", label: "Contact" },
        { to: "/privacy-en-veiligheid", label: "Privacy & veiligheid" },
      ],
    },
  ];

  return (
    <footer className="relative overflow-hidden bg-muted/60 border-t border-border text-foreground">
      <div className="relative container mx-auto px-4 pt-12 pb-8 lg:pt-14">

        {/* Brand + columns + contact in one compact grid */}
        <div className="grid gap-10 lg:grid-cols-12 lg:gap-8 mb-10">

          {/* Link columns */}
          <div className="lg:col-span-9 grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-6">
            {columns.map((col) => (
              <div key={col.title}>
                <h3 className="text-xs font-semibold text-muted-foreground/70 uppercase tracking-[0.12em] mb-4">
                  {col.title}
                </h3>
                <ul className="space-y-2.5">
                  {col.links.map((link) => (
                    <li key={link.to}>
                      <NavLink
                        to={link.to}
                        className="text-sm text-muted-foreground hover:text-primary transition-colors"
                      >
                        {link.label}
                      </NavLink>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          {/* Brand + contact in one block on the right */}
          <div className="lg:col-span-3">
            <img src={logo} alt="studie connect" className="h-8 mb-4" />
            <p className="text-sm text-muted-foreground leading-relaxed">
              Van ontdekken wie je bent tot kiezen wat bij je past. studie connect brengt de volledige LOB-reis samen in één doorlopend platform.
            </p>
            <h3 className="text-xs font-semibold text-muted-foreground/70 uppercase tracking-[0.12em] mt-8 mb-4">
              Contact
            </h3>
            <ul className="space-y-1">
              <li>
                <a
                  href="mailto:info@studie-connect.nl"
                  className="flex min-h-8 items-center gap-2.5 text-sm text-muted-foreground transition-colors hover:text-primary focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 rounded-md"
                >
                  <Mail className="w-4 h-4 shrink-0" />
                  <span>info@studie-connect.nl</span>
                </a>
              </li>
              <li>
                <a
                  href={GENERAL_PHONE.href}
                  aria-label={GENERAL_PHONE.ariaLabel}
                  onClick={() => trackPhoneClick("footer")}
                  className="flex min-h-8 items-center gap-2.5 text-sm text-muted-foreground transition-colors hover:text-primary focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 rounded-md"
                >
                  <Phone className="w-4 h-4 shrink-0" />
                  <span>{GENERAL_PHONE.display}</span>
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="pt-6 border-t border-border flex flex-col md:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-4 text-xs text-muted-foreground">
            <span className="flex items-center gap-2">
              <span className="relative flex h-2 w-2">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-[hsl(142,70%,45%)] opacity-75" />
                <span className="relative inline-flex rounded-full h-2 w-2 bg-[hsl(142,70%,45%)]" />
              </span>
              <NavLink to="/status" className="hover:text-foreground transition-colors">
                Systeeminformatie
              </NavLink>
            </span>
            <span className="text-border">·</span>
            <span>© {year} studie connect</span>
          </div>
          <div className="flex items-center flex-wrap gap-x-6 gap-y-2 justify-center text-xs">
            <NavLink to="/voorwaarden" className="text-muted-foreground hover:text-primary transition-colors">
              Voorwaarden
            </NavLink>
            <NavLink to="/privacy-statement" className="text-muted-foreground hover:text-primary transition-colors">
              Privacy
            </NavLink>
            <NavLink to="/cookiebeleid" className="text-muted-foreground hover:text-primary transition-colors">
              Cookies
            </NavLink>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
